import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrderDetailsModule } from '../order-details/order-details.module';
import { RazorpayTransactionComponent } from './razorpay-transaction/razorpay-transaction.component';
import { RazorpayRoutingModule } from './razorpay-routing.module';
import { CustomDatePipe } from './razorpay-transaction/customDate.pipe';

@NgModule({
  declarations: [
    RazorpayTransactionComponent,
    CustomDatePipe
  ],
  imports: [
    CommonModule,
    RazorpayRoutingModule,
    FormsModule,
    SharedComponentsModule,
    ReactiveFormsModule,
    OrderDetailsModule,
  ],
})
export class RazorpayModule {}
